import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AccuracyNewComponent } from './accuracy-new.component';

const routes: Routes = [{ path: '', component: AccuracyNewComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccuracyNewRoutingModule { }
